// 关键kpi
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table, Tooltip } from 'antd'
import './index.less'
const { WizSpin, WizButton, WizModal, WizCard, WizForm, WizRow, WizCol } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/cruxKpi') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackCruxKpi', record)
    } else {
      record = Session.get('trackCruxKpi') || {}
    }
  }
  return record
}

class TrackCruxKpi extends WizContainer {

  componentName = 'TrackCruxKpi'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      headList: [],
      dataList: [],
      visible: false,
      modalTitleType: 1, // 1点评 2 查看
      modalInfo: {}
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/getKpiCycleList',
      payload: {
        key: 'getKpiCycleList@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId
        }
      }
    })
  }

  markConfirmed = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/kpiCycleNoticeTargetConfirm',
      payload: {
        key: 'kpiCycleNoticeTargetConfirm@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId,
          tutorContentId: processContentId
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    markConfirmed: this._markConfirmed.bind(this),
    kpiCycleUpdate: this._kpiCycleUpdate.bind(this)
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.headList = data.headList
      nextState.dataList = data.dataList
      return true
    }
    wizNotice.error(msg || '获取关键KPI列表失败')
    return false
  }

  _markConfirmed(nextProps, nextState) {
    let { markConfirmed } = nextProps
    let { success, msg } = markConfirmed
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '达标确认失败')
    return false
  }

  _kpiCycleUpdate(nextProps, nextState) {
    let { kpiCycleUpdate } = nextProps
    let { success, msg } = kpiCycleUpdate
    if (success) {
      wizNotice.success(msg)
      nextState.visible = false
      this.getList()
      return true
    }
    wizNotice.error(msg || '点评失败')
    return false
  }

  _onBtn = (type, row) => {
    this.setState({
      modalInfo: row,
      modalTitleType: type,
      visible: true
    })
  }

  _onConfirm = () => {
    WizModal.confirm({
      title: '注意',
      content: '是否确认进行达标确认操作？',
      onOk: () => {
        this.markConfirmed()
      },
      onCancel() {
      }
    })
  }

  // modal弹出框内容
  _returnModalProps = () => {
    let { modalTitleType, visible } = this.state
    return {
      title: modalTitleType === 1 ? '点评' : '查看点评',
      visible,
      footer: null,
      width: 700,
      destroyOnClose: true,
      onCancel: () => {
        this.setState({ visible: false, modalInfo: {} })
      },
      afterClose: () => {
        this.setState({ visible: false, modalInfo: {} })
      }
    }
  }

  _onSubmitComment = (value) => {
    const { modalInfo } = this.state
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/kpiCycleUpdate',
      payload: {
        key: 'kpiCycleUpdate@' + processContentId,
        apiParams: {
          id: modalInfo.id,
          fuseTutorId: tutorId,
          ...value
        }
      }
    })
  }

  //查看点评渲染内容
  _lookComment = () => {
    let { modalInfo } = this.state
    let { state, comment } = modalInfo
    return (
      <>
        <WizRow gutter={[20, 40]}>
          <WizCol span={6} style={{ textAlign: 'right' }}>是否达标:</WizCol>
          <WizCol span={15}>{state === 1 ? '是' : '否'}</WizCol>
        </WizRow>
        <WizRow gutter={[20, 40]}>
          <WizCol span={6} style={{ textAlign: 'right' }}>点评意见:</WizCol>
          <WizCol span={15}>{comment}</WizCol>
        </WizRow>
      </>
    )
  }

  // 点评渲染内容
  _addComment = () => {

    let formColumns = [{
      title: '是否达标',
      name: 'state',
      dataIndex: 'state',
      formItem: {
        type: 'select',
        rules: [{
          required: true,
          message: '请选择是否达标',
        }],
        initialValue: ''
      },
      dict: [//需要文件夹类型的菜单数据
        { code: 1, codeName: '是' },
        { code: 0, codeName: '否' }
      ],
    }, {
      title: '点评意见',
      name: 'comment',
      formItem: {
        type: 'textarea',
        placeholder: '点评意见最多输入200个字符',
        maxLength: 200,
        rules: [{
          required: true,
          message: '请输入点评意见',
        }, {
          validator: (rule, value, callback) => {
            if (value.replace(/\s*/g, '') === '') {
              callback('点评意见不能为空')
            }
            callback();
          }
        }]
      }
    }]

    const footer = () => {
      return (
        <div className='form-btn'>
          <WizButton type='primary' htmlType='submit'>
            提交
          </WizButton>
        </div>
      )
    }

    const onSubmit = this._onSubmitComment.bind(this)
    let formProps = {
      ref: 'form',
      columns: formColumns,
      onSubmit,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }
    return (
      <WizForm {...formProps} />
    )
  }

  /**
   * 达标确认按钮是否可用
   * 列表数据不为空， 且最后一条数据内容为达标状态可用
   */
  _confirmationState = () => {
    let { dataList, record } = this.state
    let { processContentState } = record
    return processContentState === 1 || dataList.length === 0 || dataList[dataList.length - 1]['state'] !== 1
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { record, headList, dataList, modalTitleType } = this.state
    let tableProps = {
      columns: splicingHead(headList, this._onBtn),
      dataSource: splicingData(dataList),
      pagination: false,
      bordered: true,
      scroll: { x: 'max-content' },
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='关键KPI反馈'>
          <div style={{ marginBottom: 20 }}>
            <WizButton type='primary' disabled={this._confirmationState()} onClick={() => this._onConfirm()}>
              {'达标确认'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>
        <WizModal  {...this._returnModalProps()}>
          {modalTitleType === 2 ? this._lookComment() : this._addComment()}
        </WizModal>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'getKpiCycleList@' + processContentId)
  const kpiCycleUpdate = modelUtils.getModelEntity(counselingProcess, 'kpiCycleUpdate@' + processContentId) // 点评
  const markConfirmed = modelUtils.getModelEntity(counselingProcess, 'kpiCycleNoticeTargetConfirm@' + processContentId) // 达标确认
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    markConfirmed,
    kpiCycleUpdate,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackCruxKpi)



// 表格head内容体拼接
const splicingHead = (headList = [], onBtn) => {
  let headMsg = headList.map(e => {
    return {
      title: e.name,
      dataIndex: `dataIndex${e.id}`,
      key: `dataIndex${e.id}`,
      align: 'center',
      width: 150,
      render: (text, row) => {
        return (
          <Tooltip placement='topLeft' title={text} transitionName={''}>
            <div className='text-ellipsis'>
              {text}
            </div>
          </Tooltip>
        )
      }
    }
  })

  // 配置动态数据之前的内容
  let beforCol = [{
    title: '',
    dataIndex: 'cycleName',
    key: 'cycleName',
    width: 260
  }]

  // 配置动态数据之前的内容
  let afterCol = [
    {
      title: '是否达标',
      dataIndex: 'state',
      key: 'state',
      align: 'center',
      render: (text, row, index) => (text === 0 ? '否' : text === 1 ? '是' : null)
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: 200,
      render: (text, row, index) => {
        let { comment, state } = row
        return (
          <WizButton.Group>
            <WizButton type='link' disabled={state != 2} onClick={() => onBtn(1, row)}>
              {'点评'}
            </WizButton>
            <WizButton type='link' disabled={state == 2 } onClick={() => onBtn(2, row)}>
              {'查看点评'}
            </WizButton>
          </WizButton.Group>
        )
      }
    }
  ]
  return [...beforCol, ...headMsg, ...afterCol]
}

//  表格内容数据拼接
const splicingData = (dataList = []) => {
  let data = []
  dataList.map(e => {
    let obj = {
      cycleName: e.cycleName, // 第N次反馈
      reSubmit: e.reSubmit, // 是否显示重新反馈
      state: e.state === 0 ? e.state : e.state === 1 ? e.state : 2, // 是否达标
      cycle: e.cycle,
      comment: e.comment, // 点评
      trackKpis: e.trackKpis,
      id: e.id
    }
    e.trackKpis.map(c => {
      obj[`dataIndex${c.kpiId}`] = c.value // 动态标题对应内容
    })
    data.push(obj)
  })
  return data
}